var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('iframe',{staticStyle:{"position":"relative","height":"91vh","width":"100%"},attrs:{"src":"/maps/map.html","scrolling":"no","frameborder":"0"}}),(false)?_c('b-embed',{staticStyle:{"width":"100%"},attrs:{"type":"iframe","src":"https://maps-uc.web.app/map.html","allowfullscreen":""}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }